<template>
  <div class="animated fadeIn">
    <div class="row" style="padding: 0; margin: 0;">
      <div class="col-3 pt-2" style="border-right: solid 1px #efefef; background-color: rgb(237, 236, 237);">
        <LeftBarGED ref="LeftBarGED" v-on:OpenGed="onOpenGed" />
      </div>
      <div class="col-9">
        <RigthContentGED v-if="showContent" ref="RigthContentGED" v-on:ReloadMenu="onReloadMenu" v-on:Close="onClose()"/>
        <RigthContentEmptyGED v-else ref="RigthContentEmptyGED"/>
      </div>
    </div>
  </div>
</template>
<script>
import LeftBarGED from './leftcontent/leftbar.vue'
import RigthContentGED from './rightcontent/rightcontent.vue'
import RigthContentEmptyGED from './rightcontent/rightcontentempty.vue'
import { nextTick } from 'vue'

export default {
  name: 'Ged',
  data () {
    return {
      hasContent: false,
      screen: {
        leftbartSize: 2,
        rightBarSize: 10,
        windowHeight: 0
      }
    }
  },
  components: {
    LeftBarGED,
    RigthContentGED,
    RigthContentEmptyGED
  },
  computed: {
    showContent () {
      return this.hasContent
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResize)
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  methods: {
    onResize () {
      this.windowHeight = screen.width
    },
    onClose () {
      this.hasContent = false
    },
    onOpenGed (obj) {
      if (obj) {
        this.hasContent = true
        nextTick(() => {
          this.$refs.RigthContentGED.onOpen(obj)
        })
      } else {
        this.hasContent = false
      }
    },
    onReloadMenu () {
      this.$refs.LeftBarGED.onReload()
      this.hasContent = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/ged/ged.vue